import { render, staticRenderFns } from "./CrudLinkStoreCollection.vue?vue&type=template&id=04516c88&scoped=true"
import script from "./CrudLinkStoreCollection.vue?vue&type=script&lang=js"
export * from "./CrudLinkStoreCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04516c88",
  null
  
)

export default component.exports